


export default function ProcessSection() {
    const steps = [
        {
            icon: 'ri-pencil-ruler-2-line',
            title: 'Un Diseño Nuevo',
            description: 'Tengas o no una idea clara, trabajaremos juntas en tu diseño de inicio a fin para crear una pieza única.'
        },
        {
            icon: 'ri-image-add-line',
            title: 'Ya tengo el Diseño',
            description: 'Si ya tienes tu diseño listo, nuestras artistas lo harán realidad con la mejor técnica y precisión.'
        },
        {
            icon: 'ri-book-open-line',
            title: 'Elegir de Catálogo',
            description: 'Explora nuestros flash tattoos y diseños disponibles listos para ser tatuados.'
        },
        {
            icon: 'ri-magic-line',
            title: 'Cover Up',
            description: 'Si tienes un tatuaje antiguo que quieres cubrir o transformar, cuéntanos su historia y lo renovaremos.'
        },
        {
            icon: 'ri-chat-heart-line',
            title: 'Asesoría Completa',
            description: 'Si tienes dudas o no sabes qué hacerte, te guiaremos en todo el proceso con paciencia y profesionalismo.'
        }
    ];

    return (
        <section id="proceso" className="py-20 bg-white">
            <div className="container mx-auto px-6">
                <div className="text-center mb-16">
                    <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
                        ¿Cómo podemos <span className="text-pink-500">Ayudarte?</span>
                    </h2>
                    <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                        Sea cual sea tu idea, tenemos diferentes formas de plasmarla en tu piel
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
                    {steps.map((step, index) => (
                        <div
                            key={index}
                            className="bg-pink-50 rounded-2xl p-8 hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1 border border-pink-100/50"
                        >
                            <div className="w-14 h-14 bg-white rounded-xl flex items-center justify-center mb-6 shadow-sm text-pink-500">
                                <i className={`${step.icon} text-2xl`}></i>
                            </div>
                            <h3 className="text-xl font-bold text-gray-900 mb-3">{step.title}</h3>
                            <p className="text-gray-600 leading-relaxed text-sm">
                                {step.description}
                            </p>
                        </div>
                    ))}

                    {/* Card de llamada a la acción para completar el grid */}
                    <div className="bg-gradient-to-br from-pink-500 to-purple-600 rounded-2xl p-8 text-white flex flex-col justify-center items-center text-center shadow-lg transform hover:scale-105 transition-transform duration-300">
                        <h3 className="text-2xl font-bold mb-3">¿Lista para empezar?</h3>
                        <p className="text-white/90 mb-6 text-sm">
                            Cuéntanos tu idea y hagamos realidad tu próximo tatuaje
                        </p>
                        <a
                            href="https://wa.me/56982504829"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="bg-white text-pink-600 px-6 py-2 rounded-full font-bold text-sm hover:bg-gray-100 transition-colors inline-flex items-center"
                        >
                            <i className="ri-whatsapp-line mr-2"></i>
                            Escribir ahora
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
}
